import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="flex space-x-2 bg-white shadow-md rounded-full p-2" dir="ltr">
                <button 
           onClick={() => changeLanguage('en')} 
             className={`px-3 py-1 rounded-full ${i18n.language === 'en' ? 'bg-primary-600 text-white' : 'text-gray-700'}`}
        >
          EN
        </button>
        <button 
          onClick={() => changeLanguage('de')} 
          className={`px-3 py-1 rounded-full ${i18n.language === 'de' ? 'bg-primary-600 text-white' : 'text-gray-700'}`}
        >
          DE
        </button>
        <button 
          onClick={() => changeLanguage('ar')} 
          className={`px-3 py-1 rounded-full ${i18n.language === 'ar' ? 'bg-primary-600 text-white' : 'text-gray-700'}`}
        >
          AR
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;